<template>
  <div class="bottom-nav-container">
    <v-bottom-navigation :elevation="0" class="creative-glass-nav" grow style="bottom: 0px !important;">
      
      <v-btn :to="{ name: 'Dashboard' }" class="nav-btn" v-if="$abillity.can('read', 'panel-metricas')" active-class="btn-active">
        <div class="icon-wrapper">
          <v-icon class="nav-icon">fa:fa-solid fa-gauge</v-icon>
        </div>
        <span class="nav-label">Dashboard</span>
      </v-btn>

      <v-btn :to="{ name: 'profileUser' }" class="nav-btn" active-class="btn-active">
        <div class="icon-wrapper">
          <v-icon class="nav-icon">fa:fa-solid fa-user</v-icon>
        </div>
        <span class="nav-label">Perfil</span>
      </v-btn>

      <v-btn :to="{ name: 'tickets' }" class="nav-btn" v-if="$abillity.can('read', 'tickets-area')" active-class="btn-active">
        <div class="icon-wrapper">
          <v-icon class="nav-icon">mdi:mdi-ticket-outline</v-icon>
        </div>
        <span class="nav-label">Tickets</span>
      </v-btn>

      <v-btn :to="{ name: 'usuarios' }" class="nav-btn" v-if="$abillity.can('read', 'usuarios-area')" active-class="btn-active">
        <div class="icon-wrapper">
          <v-icon class="nav-icon">mdi:mdi-account-search</v-icon>
        </div>
        <span class="nav-label">Usuarios</span>
      </v-btn>

    </v-bottom-navigation>
  </div>
</template>

<style scoped>
/* Contenedor Principal */
.bottom-nav-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0;
}

/* Navegación Glass Moderna */
.creative-glass-nav {
  pointer-events: auto;
  background: rgba(19, 17, 28, 0.92) !important;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1.5px solid rgba(255, 255, 255, 0.18);
  border-bottom: none;
  
  box-shadow: 
    0 -8px 32px -8px rgba(0, 0, 0, 0.6),
    0 2px 8px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  
  max-width: 480px;
  width: 100%;
  height: 68px !important;
  border-radius: 20px 20px 0 0 !important;
  margin: 0 !important;
  padding: 0 0.5rem;
}

/* Botones de Navegación */
.nav-btn {
  background: transparent !important;
  color: #9CA3AF !important;
  height: 100% !important;
  min-width: auto !important;
  flex-direction: column !important;
  gap: 0.25rem;
  padding: 0.5rem 0.25rem !important;
  border-radius: 16px !important;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.nav-btn:hover:not(.btn-active) {
  color: #D1D5DB !important;
}

.nav-btn:hover:not(.btn-active) .icon-wrapper {
  transform: translateY(-2px) scale(1.05);
  background: rgba(255, 255, 255, 0.05);
}

/* Wrapper del Icono */
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  background: transparent;
}

.nav-icon {
  font-size: 20px !important;
  transition: all 0.3s ease;
}

/* Label del Botón */
.nav-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  opacity: 0.65;
  transition: all 0.3s ease;
  line-height: 1;
  margin-top: -2px;
}

/* Estado Activo */
.btn-active {
  color: white !important;
}

.btn-active .icon-wrapper {
  transform: translateY(-4px) scale(1.08);
  background: linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%) !important;
  box-shadow: 
    0 8px 24px -4px rgba(236, 72, 153, 0.5),
    0 4px 12px rgba(139, 92, 246, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.btn-active .nav-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.btn-active .nav-label {
  opacity: 1;
  color: #F9A8D4 !important;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Indicador de Página Activa - Punto Superior */
.btn-active::before {
  content: '';
  position: absolute;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: linear-gradient(135deg, #EC4899, #F472B6);
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(236, 72, 153, 0.8);
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
  50% {
    opacity: 0.6;
    transform: translateX(-50%) scale(1.2);
  }
}

/* Responsive - Tablet */
@media (max-width: 768px) {
  .creative-glass-nav {
    max-width: 100%;
    height: 64px !important;
    border-radius: 18px 18px 0 0 !important;
  }
  
  .icon-wrapper {
    width: 40px;
    height: 40px;
  }
  
  .nav-icon {
    font-size: 19px !important;
  }
  
  .nav-label {
    font-size: 9.5px;
  }
}

/* Responsive - Móvil */
@media (max-width: 480px) {
  .creative-glass-nav {
    height: 60px !important;
    border-radius: 16px 16px 0 0 !important;
    padding: 0 0.25rem;
  }
  
  .nav-btn {
    padding: 0.4rem 0.2rem !important;
    gap: 0.2rem;
  }
  
  .icon-wrapper {
    width: 38px;
    height: 38px;
    border-radius: 12px;
  }
  
  .nav-icon {
    font-size: 18px !important;
  }
  
  .nav-label {
    font-size: 9px;
  }
  
  .btn-active .icon-wrapper {
    transform: translateY(-3px) scale(1.05);
  }
}

/* Móvil Pequeño */
@media (max-width: 360px) {
  .creative-glass-nav {
    height: 56px !important;
    border-radius: 14px 14px 0 0 !important;
  }
  
  .icon-wrapper {
    width: 36px;
    height: 36px;
  }
  
  .nav-icon {
    font-size: 17px !important;
  }
  
  .nav-label {
    font-size: 8.5px;
  }
}

/* Safe Area para iPhone con notch */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .bottom-nav-container {
    padding-bottom: env(safe-area-inset-bottom);
  }
  
  .creative-glass-nav {
    padding-bottom: calc(0.5rem + env(safe-area-inset-bottom)) !important;
  }
}
</style>